(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3790],{

/***/ 13742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Check; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]];
const Check = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("check", __iconNode);


//# sourceMappingURL=check.js.map


/***/ }),

/***/ 96712:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/contract-lifecycle",
      function () {
        return __webpack_require__(34870);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const CLMHero2 = (param)=>{
    let { CLMHeroData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ",
                        children: [
                            CLMHeroData.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl text-violet-600 uppercase",
                                children: CLMHeroData.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold",
                                children: CLMHeroData.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg font-medium text-gray-800 md:text-2xl text-center md:w-[80%]",
                                children: CLMHeroData.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary */ .IS, {
                                buttonText: CLMHeroData.btnText,
                                buttonUrl: CLMHeroData.btnUrl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl md:mx-8 mx-auto pt-8",
                        children: [
                            CLMHeroData.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: CLMHeroData.video,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl",
                                autoPlay: true,
                                loop: true,
                                muted: true
                            }),
                            CLMHeroData.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: CLMHeroData.image,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CLMHero2);


/***/ }),

/***/ 24062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13742);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





const EqualDivisionSection = (param)=>{
    let { title , heading , description , checks , image ="" , video ="" , bgColor , imageRight =true , opinion , imageRounded =true , leftDivStyle =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(bgColor, " py-7 md:py-32 transition-all duration-700"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto grid md:grid-cols-2 gap-6 md:gap-12 xl:gap-20 items-start ".concat(leftDivStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(imageRight ? "md:order-1" : "md:order-2", " order-1"),
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "uppercase text-purple-900 mb-2 text-xs md:text-base font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "", " text-[28px]  md:text-4xl xl:text-5xl font-semibold text-start ").concat(heading && "mb-6"),
                            children: heading
                        }),
                        description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-900", " mb-6  md:text-2xl font-semibold md:font-normal font-medium text-left"),
                            children: description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "space-y-4 ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-800", " text-lg md:leading-none xl:leading-relaxed"),
                            children: checks.map((check, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: "flex items-start text-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 text-gray-800 bg-purple-200 rounded-full p-1 mr-2 mt-1 shrink-0"
                                        }),
                                        check
                                    ]
                                }, idx))
                        }),
                        opinion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-black", " mb-6  md:text-base w-[70%] pl-4 font-semibold font-medium mt-10 text-start hidden md:block"),
                            children: [
                                opinion,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-BoloSign User"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "bg-color  rounded-2xl relative  ".concat(imageRight ? "order-2" : "order-1"),
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: image,
                            alt: "Contract Creation",
                            width: 500,
                            height: 500,
                            className: "w-full ".concat(imageRounded ? "rounded-2xl" : "")
                        }),
                        video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            src: video,
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            className: "w-full h-full object-cover rounded-2xl"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EqualDivisionSection);


/***/ }),

/***/ 34870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29937);
/* harmony import */ var components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24062);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43138);








const CLMHeroData = {
    // title: "Reporting",
    heading: "Edit, track, automate, and optimize contracts in one CLM",
    description: "Manage contracts Lifecycle from draft to renewal with built-in editing, tracking, automation, and analytics.",
    // image: `${BASE_ASSETS_URL}/v2/clm/clm/contract-management-hero.gif"),
    video: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/videos/contract-management-hero.mp4"),
    btnText: "Take a Quick Demo",
    btnUrl: "/clm/request-demo"
};
const ContractManagement = ()=>{
    const sectionRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .useInView */ .Y)(sectionRef, {
        once: false,
        amount: 0.5
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Contract Management Software | BoloSign CLM Contract Lifecycle"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "BoloSign CLM is a contract management software that helps legal teams draft, review, automate, and optimize contracts faster with built-in contract lifecycle management."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Contract management software, CLM software, contract lifecycle management, contract automation, contract tracking, contract analytics, BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/contract-lifecycle/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                CLMHeroData: CLMHeroData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title="Templates"
                heading: "Edit, collaborate, and review contracts",
                description: "Work in Microsoft Word’s interface, collaborate in real-time, and review with AI—all without leaving BoloSign.",
                // image={`${BASE_ASSETS_URL}/v2/clm/clm/contract-management-edit.gif")}
                video: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/videos/contract-management-edit.mp4"),
                bgColor: "bg-transparent",
                imageRight: true,
                checks: [
                    "Edit in Word, Stay in BoloSign – Draft, edit, and save contracts with formatting and comments fully preserved.",
                    "Collaborate in Real-Time – Co-edit with your team, track changes, and manage internal vs external comments.",
                    "Review with AI – Use smart playbooks to automate checks, redlines, and policy compliance."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "text-black px-6 md:px-8 mb-10 md:mb-28 mt-10 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-screen-xl xl:px-8 mx-auto flex flex-col md:flex-row gap-6 justify-between items-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center flex flex-col items-center md:gap-3 mb-6 md:mb-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-version.png"),
                                    alt: "filter-by",
                                    width: 300,
                                    height: 300,
                                    className: "w-full h-full rounded-2xl"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-start",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xl md:text-2xl",
                                        children: "Draft, review, and store all contracts with full version control"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center flex flex-col items-center md:gap-3 mb-6 md:mb-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-monitor.gif"),
                                    alt: "expiry-is",
                                    width: 300,
                                    height: 300,
                                    className: "w-full h-full"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-start",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xl md:text-2xl",
                                        children: "Monitor progress, spot delays, and share insights across teams"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center flex flex-col items-center md:gap-3 mb-6 md:mb-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-agreement.png"),
                                    alt: "custom-view",
                                    width: 300,
                                    height: 300,
                                    className: "w-full h-full rounded-2xl"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-start",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xl md:text-2xl",
                                        children: "Set custom approval flows, clickwrap agreements, and get deals done faster"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: sectionRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    // title="Templates"
                    heading: "Unlock insights from every contract",
                    description: "Turn your contracts into a source of truth with real-time dashboards, actionable data, and smarter workflows—all in BoloSign.",
                    image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-unlock.gif"),
                    bgColor: isInView ? "bg-dark" : "bg-transparent",
                    imageRight: true,
                    checks: [
                        "Visualize the Full Lifecycle – Track every stage from draft to signature with 30+ real-time metrics and turnaround time insights.",
                        "Optimize Workflows with Data – Identify bottlenecks, improve SLAs, and streamline high-volume contracts like NDAs and MSAs.",
                        "Align Legal and Business Teams – Share clear reports and success metrics to drive collaboration and showcase legal’s impact."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title="Templates"
                heading: "See what your contracts are really telling you",
                description: "BoloSign turns contract data into powerful insights—so you can search smarter, report faster, and optimize every workflow with ease.",
                image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-see.gif"),
                bgColor: "bg-transparent",
                imageRight: false,
                checks: [
                    "Smart Search & Filters – Find contracts by terms, dates, revenue, or parties; save custom views that auto-update as new contracts arrive.",
                    "Automated Reports – Schedule recurring reports from saved views and share them across departments for better decision-making.",
                    "Workflow Insights – Identify bottlenecks, track team workloads, and improve turnaround times with real-time, actionable analytics."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title="Templates"
                heading: "Centralize every contract in one smart hub",
                description: "BoloSign gives you a secure, AI-powered space to store, search, and manage contracts—making it easy to access insights, stay compliant, and work faster.",
                image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-centralize.gif"),
                bgColor: "bg-cream",
                imageRight: true,
                checks: [
                    "Find What You Need, Fast – Use full-text search, smart filters, and saved views to instantly locate any contract.",
                    "Automate & Enrich Data – Auto-extract metadata, link related docs, and generate reports without manual effort.",
                    "Stay Secure & Compliant – Protect sensitive data with encryption, role-based access, and detailed audit logs."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title="Templates"
                heading: "Secure, trackable clickwraps for high-scale workflows",
                description: "BoloSign makes it easy to embed, manage, and track user agreements—ensuring legal proof, version control, and full visibility for your team.",
                // image={`${BASE_ASSETS_URL}/v2/clm/clm/contract-management-secure-1.gif")}
                video: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/videos/contract-management-secure-1.mp4"),
                bgColor: "bg-transparent",
                imageRight: false,
                checks: [
                    "Embed in Minutes – Add clickwraps to your site with a simple snippet—no dev time or complex setup required.",
                    "Capture Legally Enforceable Consent – Track every acceptance with time, IP, and identity for audit-ready records.",
                    "Centralize & Manage Versions – Auto-update terms, track who accepted what, and give legal full oversight from one hub."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title="Templates"
                heading: "Automate every step of your contract process",
                description: "From drafting to approvals and signatures, BoloSign lets you build error-free, no-code workflows that move contracts faster—right inside your favorite tools.",
                image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-msa.gif"),
                bgColor: "bg-dark",
                imageRight: true,
                checks: [
                    "Generate Contracts Instantly – Auto-fill templates with form data to create accurate, ready-to-send contracts—no edits needed.",
                    "Work From Your Existing Tools – Create, send, and track contracts directly from platforms like Airtable, HubSpot, and Pipedrive.",
                    "Streamline Approvals & Reviews – Use smart routing, intake forms, and real-time tracking to eliminate delays and manual follow-ups."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-0 md:px-8 bg-cream",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: " max-w-screen-xl mx-auto px-6 xl:px-8 md:py-32 py-16 text-black md:rounded-2xl flex flex-col md:flex-row justify-between ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full mb-6 md:mb-0 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-2xl md:text-4xl xl:text-5xl font-semibold mb-4 xl:mb-8",
                                    children: "Here’s how Shine Above uses BoloSign CLM"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-feedback.png"),
                                    alt: "Customer discussion",
                                    className: "w-[90%]",
                                    width: 500,
                                    height: 500
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full md:w-2/3 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-brown.png"),
                                alt: "Customer discussion",
                                className: "w-full",
                                width: 500,
                                height: 500
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ContractManagement);


/***/ }),

/***/ 16893:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/motion-dom/dist/es/utils/resolve-elements.mjs
var resolve_elements = __webpack_require__(11816);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/viewport/index.mjs


const thresholds = {
    some: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "some" } = {}) {
    const elements = (0,resolve_elements/* resolveElements */.I)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry.target, entry);
                if (typeof newOnEnd === "function") {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (typeof onEnd === "function") {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false, initial = false, } = {}) {
    const [isInView, setInView] = (0,react.useState)(initial);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once, amount]);
    return isInView;
}




/***/ }),

/***/ 11816:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ resolveElements; }
/* harmony export */ });
function resolveElements(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) {
        return [elementOrSelector];
    }
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) {
            root = scope.current;
        }
        const elements = selectorCache?.[elementOrSelector] ??
            root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(96712); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);